import PropTypes from "prop-types";
import React from "react";
import InputRangeSlider from "../../InputRangeSlider";
import { RangePropType } from "../../../../PropTypes";

const DistanceRangeFilter = props => {
    const { name, label, hideLabel, labelId, value, min, max, onChange, onInput, disabled = false, step = 1 } = props;

    return (
        <InputRangeSlider
            multiple={true}
            label={label}
            hideLabel={hideLabel}
            labelId={labelId}
            name={name}
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={onChange}
            onInput={onInput}
            disabled={disabled}
        />
    );
};

DistanceRangeFilter.propTypes = {
    name: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    hideLabel: PropTypes.bool,
    labelId: PropTypes.string,
    value: RangePropType.isRequired,
    unit: PropTypes.string,
    onChange: PropTypes.func,
    onInput: PropTypes.func,
    disabled: PropTypes.bool,
    step: PropTypes.number,
};

export default DistanceRangeFilter;
